import * as types from './types';

export const changeLanguage = language => ({
  type: types.LANGUAGE_CHANGE,
  language
});
